import type { CategoryColor } from "@simplicity/ui";
import { CategoryBadge } from "@simplicity/ui";

const TYPE_COLORS: Record<string, CategoryColor> = {
  powerschools: "blue",
  skyward: "purple",
  deanslist: "green",
  "iready-sftp": "amber",
  schoolmint: "teal",
  bigquery: "blue-light",
  "bigquery-experimental": "blue-light",
  "bigquery-nodedup": "blue-light",
  avela: "orange",
  "schoolmint-enroll": "teal",
  "file-drop": "slate",
  dna: "violet",
};

const TYPE_LABELS: Record<string, string> = {
  powerschools: "PowerSchool",
  "powerschool-enrollment": "PS Enrollment",
  skyward: "Skyward",
  deanslist: "DeansList",
  "iready-sftp": "iReady SFTP",
  schoolmint: "SchoolMint",
  "schoolmint-enroll": "SchoolMint Enroll",
  "file-drop": "File Drop",
  avela: "Avela",
  dna: "Renaissance DnA",
  bigquery: "BigQuery",
  "bigquery-experimental": "BigQuery Experimental",
  "bigquery-nodedup": "BigQuery Nodedup",
};

const DEFAULT_COLOR: CategoryColor = "blue";

function displayLabel(type: string): string {
  return TYPE_LABELS[type.toLowerCase()] ?? type.charAt(0).toUpperCase() + type.slice(1);
}

export function TypeBadge({ type }: { type: string }) {
  const color = TYPE_COLORS[type.toLowerCase()] ?? DEFAULT_COLOR;
  return <CategoryBadge color={color}>{displayLabel(type)}</CategoryBadge>;
}
